import {
    ActionTypes,
    ISetContainerRefAction,
    TContainerRef
} from './types';

export function setContainerRef(ref: TContainerRef): ISetContainerRefAction {
    return { type: ActionTypes.SetContainerRef, payload: { ref } };
}
